import type { ChipProps } from '@mui/material';
import { Add } from '@mui/icons-material';
import { Chip, Tooltip } from '@mui/material';
import { useMessageService } from '@/shared/services/MessageService/MessageServiceContext';
import FollowCompanyModal from '../Modals/FollowCompanyModal';

interface ManageFollowedCompaniesButtonProps extends ChipProps {
  highlighted?: boolean;
}

export function ManageFollowedCompaniesButton({ highlighted, ...props }: ManageFollowedCompaniesButtonProps) {
  const { openMessage } = useMessageService();

  return (
    <Tooltip
      title="Follow companies you are interested in (typically key prospects or existing accounts) for relevant updates and insights"
      placement="top"
    >
      <Chip
        component="span"
        label="Manage Followed Companies"
        icon={<Add />}
        sx={{
          backgroundColor: 'white',
          height: '44px',
          ...(highlighted && {
            animation: 'pulse 2s infinite',
            '@keyframes pulse': {
              '0%': {
                transform: 'scale(1)',
                boxShadow: '0 0 0 0 rgba(25, 118, 210, 0.4)',
              },
              '50%': {
                transform: 'scale(1.02)',
                boxShadow: '0 0 0 8px rgba(25, 118, 210, 0.1)',
              },
              '100%': {
                transform: 'scale(1)',
                boxShadow: '0 0 0 0 rgba(25, 118, 210, 0)',
              },
            },
          }),
        }}
        variant="outlined"
        data-testid="manage-prospect-list-button"
        color="primary"
        onClick={() => {
          openMessage({
            modalType: 'action',
            header: 'Manage Followed Companies',
            customBody: <FollowCompanyModal />,
            size: 'xlarge',
          });
        }}
        {...props}
      />
    </Tooltip>
  );
}
